// StatusModal.jsx
import React from "react";
import { Typography } from "@material-tailwind/react";
import circleAlert from "../../assets/images/alert-circle.svg"
import circleSuccess from "../../assets/images/checkmark-circle.svg"

const StatusModal = ({ isOpen, title, message, onClose, onNavigate, isSuccess }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-gray-900 opacity-50 backdrop-filter backdrop-blur-sm z-40"></div>
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 p-4 sm:p-6 z-50 text-center">
        <img src={isSuccess ? circleSuccess : circleAlert} alt="status icon" className="mx-auto mb-4 w-12 h-12" />

        <Typography variant="h6">{title}</Typography>
        <Typography variant="small">{message}</Typography>
        <div className="mt-4 flex flex-col sm:flex-row justify-center gap-3 sm:gap-x-4">
        <button
          onClick={() => {
            onClose()
          }}
          className="mt-4 w-full sm:w-auto bg-[#FFFFFF] text-black py-2 px-4 rounded-lg border border-gray-300"
        >
            {isSuccess ? "Continue Editing" : "Leave Anyway"}
        </button>
        <button
          onClick={() => {
            onClose()
            if(isSuccess && onNavigate) onNavigate();
          }}
          className="mt-4 w-full sm:w-auto bg-[#344054] text-white py-2 px-4 rounded-lg"
        >
            {isSuccess ? "Go To Dashboard" : "Stay On Event Page"}
        </button>
        </div>
      </div>
    </div>
  );
};

export default StatusModal;